module.exports = __webpack_public_path__ + "static/media/chiken_side2.c757e847.png";